import { RobotModel } from '@/interfaces'

export const HORST_HSE_600: RobotModel = {
  id: 'e4bc55d8-8a5a-4b57-a02a-caa442654e0e',
  name: 'HORST600 G2',
  systemDisplayConfiguration: {
    image: new URL(`/src/assets/systems/HSE_600.png`, import.meta.url).href,
  },
  maintenanceDisplayConfiguration: {
    image: new URL(`/src/assets/robots/600.png`, import.meta.url).href,
  },
  axisMaxRotations: [7_725_000, 6_100_000, 17_076_000, 5_171_000, 8_514_000, 22_503_000], //TODO: Used values from HORST_600.ts. Might have to adjust these

  selectable: true,
}
